import { useMutation } from 'react-query'
import { api } from '../../../api'

const removeAsset = async (id: number) => {
  return api.delete(`/assets/${id}`)
}

export const useAssetRemoveMutation = () => {
  return useMutation('remove-asset', removeAsset)
}
